import React from "react";
import { pure } from "recompose";

import TeamDecision from "./TeamDecision";
import Goal from "./Goal";

const TeamDecisions = pure(props => {
  const roles = {
    CEO: "CEO",
    PD: "Head of Product",
    PM: "Head of Marketing",
    OP: "Head of Operations",
    FI: "Head of Finance"
  };

  const mappedRoles = Object.keys(roles).map(r => ({
    role: r,
    name: props.role === r ? `${roles[r]} (You)` : roles[r]
  }));

  return (
    <div className="team-decisions">
      <div className="team-decisions__header">
        <p className="team-decisions__title">Decision Submission Status</p>
        <Goal name="incomplete" />
        <Goal name="complete" checked />
      </div>

      <div className="team-decisions__body">
        {mappedRoles.map(role => (
          <TeamDecision key={role.role} {...props} {...role} />
        ))}
      </div>
    </div>
  );
});

export default TeamDecisions;



// WEBPACK FOOTER //
// ./src/components/dashboard/TeamDecisions.js